//Header sub-menu hiding.
if( document.querySelector('.js-nav-burger') ) {
	let burger = document.querySelector('.js-nav-burger');
	burger.addEventListener('click', function() {
		this.querySelector('.navbar__burger__line--top').classList.toggle('navbar__burger__line--top--open');
		this.querySelector('.navbar__burger__line--middle').classList.toggle('hide');
		this.querySelector('.navbar__burger__line--bottom').classList.toggle('navbar__burger__line--bottom--open');

		document.querySelector('.js-navbar-flyout').classList.toggle('navbar__flyout--open');
	});
}


//Login switching
if( document.querySelector('.js-login-form-toggle') ) {
	let triggers = document.querySelectorAll('.js-login-form-toggle-button');
	triggers.forEach(function(button) {
		button.addEventListener('click', function() {
			let open = this.dataset.formopen;
			let close = this.dataset.formclose;

			document.querySelector('[data-formtype="'+open+'"]').classList.remove('hide');
			document.querySelector('[data-formtype="'+close+'"]').classList.add('hide');

			if(this.classList.contains('login-container--active')) {

			} else {
				this.classList.add('login-container--active');
				document.querySelector('[data-formclose="'+open+'"]').classList.remove('login-container--active');
			}
		})
	});
}


//HOME PAGE SLIDER
if( document.querySelector('.js-slider') ) {
	const slideCount = document.querySelector('.js-slider').dataset.slidecount;
	const grid = document.querySelector('.js-slider-grid');
	let currentSlide = 0;
	let baseWidth = -100;
	// let baseOffset = 0.9375;

	function sliderActive() {
		currentSlide++;

		if(currentSlide == slideCount) {
			currentSlide = 0;
			grid.setAttribute('style', '');
		} else {
			let newWidth = baseWidth*currentSlide;
			// let newOffset = baseOffset*currentSlide;

			//set the attribute here
			grid.setAttribute('style', 'margin-left: '+newWidth+'vw');
			// grid.setAttribute('style', 'margin-left: calc('+newWidth+'vw - '+newOffset+'rem)');
		}


		//callback function
		setTimeout(sliderActive, "7500");
	}

	setTimeout(sliderActive, "7500");

}


//FAQ Accordian
if( document.querySelector('.js-faq-accordian') ) {
	let trigger = document.querySelectorAll('.js-faq-trigger');

	trigger.forEach(function(trig) {
		trig.addEventListener('click', function() {
			let target = this.dataset.faqtrigger;

			this.classList.toggle('product__faq__chevron--open');

			document.querySelector('[data-faqcontent="'+target+'"]').classList.toggle('product__faq__content--hidden');
		});
	});
}



//Filter the products
if ( document.querySelector('.js-product-filters') ) {
	let filteredTerms = [];
	//get all the filters
	let filterButtons = document.querySelectorAll('.js-option');

	//get all the products
	let product = document.querySelectorAll('.js-product-a');

	filterButtons.forEach( (e) => {
		e.addEventListener('click', function(){
			this.classList.toggle('tax__filters--option--selected');
			let category = this.dataset.category;

			//if the button is selected, add to the array, else remove.
			if( this.classList.contains('tax__filters--option--selected') ) {
				filteredTerms.push(category);
			} else {
				const index = filteredTerms.indexOf(category);
				if (index > -1) { // only splice array when item is found
					filteredTerms.splice(index, 1); // 2nd parameter means remove one item only
				}
			}

			let i = 0;
			//lets loop through the items here
			product.forEach( (e) => {

				let categories = e.dataset.category;
				categories = categories.split(' ');
				
				if( filteredTerms.some(f => categories.includes(f) ) ) {
					e.classList.remove('hide');
					i++;
				} else {
					e.classList.add('hide');
				}
			});

			if( filteredTerms.length == 0 ) {
				product.forEach( (e) => {
					e.classList.remove('hide');
					i++;
				});
			}

			if( i < 1 ) {
				document.querySelector('.js-oos').classList.remove('hide');
			} else {
				document.querySelector('.js-oos').classList.add('hide');
			}

		});
	});

	let filtersToggled = 0;

	document.querySelector('.js-filters-show').addEventListener('click', function() {
		filtersToggled++;

		if( isOdd(filtersToggled) ) {
			//show
			document.querySelector('.js-filters-container').classList.remove('hide');
			document.querySelector('.js-filters-show').innerHTML = 'Hide Filters <i class="fa-solid fa-chevron-up"></i>';
		} else {
			//hide
			document.querySelector('.js-filters-container').classList.add('hide');
			document.querySelector('.js-filters-show').innerHTML = 'Show Filters <i class="fa-solid fa-chevron-down"></i>';

		}

	});

}

let intervalID = '';


//Advert Slider
if( document.querySelector('.js-adverts') ) {
	const adverts = document.querySelector('.js-adverts').dataset.slides;
	const advertsArray = adverts.split(',');
	const advertImage = document.querySelector('.js-adverts-image');
	
	let step = 0;
	let slider = () => {
		advertImage.src = advertsArray[step];
		step < advertsArray.length - 1 ? step++ : step = 0;

		setTimeout("slider()", 7500);
	}

	slider();
}

//tabs button
if( document.querySelector('.js-tv-input') ) {
	const update = document.querySelector('.js-update-button');

	function updateButton() {
		update.innerHTML = 'Update Displays <i class="fa-solid fa-spinner"></i>';
		update.classList.add('tv__button--attention');

	}

	let tabs = document.querySelectorAll('.js-output-tab');

	tabs.forEach( (e) => {
		e.addEventListener('click', function() {
			updateButton();

			tabs.forEach( (e) => {
				e.classList.remove('tv__button--active');
			});

			e.classList.add('tv__button--active');

			//set the data tabs here
			document.querySelectorAll('[data-content]').forEach( (e) => {
				e.classList.add('hide');
			});

			document.querySelector('[data-content="'+e.dataset.tab+'"]').classList.remove('hide');
			document.querySelector('.js-tv-input').dataset.current = e.dataset.tab;
		});
	});

	//textarea change update.
	document.querySelector('.js-text-area').addEventListener('input', function() {
		updateButton();
	});

	update.addEventListener('click', function() {
		update.innerHTML = 'Displays up to date';
		update.classList.remove('tv__button--attention');

		let informationTab = document.querySelector('.js-tv-input').dataset.current;
		let informationColour = document.querySelector('.js-tv-input').dataset.colour;
		let informationDisplays = document.querySelector('.js-tv-input').dataset.displays;
		let informationName = document.querySelector('.js-tv-input').dataset.name;
		let informationTableNumbers = document.querySelector('.js-toggle-table-numbers').dataset.tablenumbers;
		let eventBG = document.querySelector('.js-tv-input').dataset.bg;


		let informationInfo = '';
		let hours = '';
		let minutes = '';
		let seconds = '';

		if( informationTab == 'pairings' ) {
			var arrayOfLines = document.querySelector('.js-text-area').value.split('\n');
			informationInfo = arrayOfLines;
		}
		if( informationTab == 'timer' ) {
			hours = document.querySelector('.js-hours');
			minutes = document.querySelector('.js-minutes');
			seconds = document.querySelector('.js-seconds');
		}

		if( informationTab == 'image' ) {
			informationInfo = document.querySelector('.js-image-preview').src;
		}

		//send the data to the ajax controller so it web socket updates everything
		jQuery.ajax({
			type: "post",
			url: `${window.location.origin}/wp-admin/admin-ajax.php`,
			data: {
				action: "update_tv_display",
				tab: informationTab,
				colour: informationColour,
				displays: informationDisplays,
				name: informationName,
				tableNumbers: informationTableNumbers,
				info: informationInfo,
				bg: eventBG
			},
			complete: function( response ) {
				
			}
		})
	});

	//Add the data for table numbers toggling 
	document.querySelector('.js-toggle-table-numbers').addEventListener('click', function(e) {
		let bool = this.dataset.tablenumbers;
		if( bool == 1 ) {
			bool = 0;
			this.dataset.tablenumbers = bool;
			this.classList.remove('tv__button--active');
			this.innerHTML = 'Table numbers hidden';
			updateButton();
		} else {
			bool = 1;
			this.dataset.tablenumbers = bool;
			this.classList.add('tv__button--active');
			this.innerHTML = 'Table numbers active';
			updateButton();
		}
	});
}

//This is for the product searching
if( document.querySelector('.js-product-search') ) {
	const inputSearch = document.querySelector('.js-product-search');
	const searchResults = document.querySelector('.js-search-results');
	inputSearch.addEventListener('input', () => {
		if(inputSearch.value.length >= 3 ) {
			
			jQuery.ajax({
				type: "post",
				url: `${window.location.origin}/wp-admin/admin-ajax.php`,
				data: {
					action: "fetch_product_details",
					terms: inputSearch.value
				},
				complete: function( response ) {
					searchResults.classList.remove('hide');
					searchResults.innerHTML = '';

					let events = response.responseJSON;

					events.forEach((e) => {
						let aTag = document.createElement('a');
						aTag.setAttribute('href', '../order-list?pid='+e['id']);

						let imgTag = document.createElement('img');
						imgTag.setAttribute('src', e['image']);

						let divTag = document.createElement('div');
						divTag.innerHTML = e['name'];

						aTag.appendChild(imgTag);
						aTag.appendChild(divTag);

						searchResults.appendChild(aTag);
					});
				}
			})

		} else {
			searchResults.classList.add('hide');
		}
	});
}

//timer js

let countDirectionDown = true;
let countDownPrefix = '';

if( document.querySelector('.js-timer-control') ) {

	let hoursContainer = document.querySelector('.js-hours');
	let minutesContainer = document.querySelector('.js-minutes');
	let secondsContainer = document.querySelector('.js-seconds');
	let eventBG = document.querySelector('.js-tv-input').dataset.bg;

	document.querySelector('.js-timer-control').addEventListener('click', () => {
		let hours = Number(hoursContainer.innerHTML);
		let minutes = Number(minutesContainer.innerHTML);
		let seconds = Number(secondsContainer.innerHTML);
		let timer = countdown(hours, minutes, seconds);
		document.querySelector('.js-update-button').innerHTML = 'Displays up to date';
		document.querySelector('.js-update-button').classList.remove('tv__button--attention');

		document.querySelector('.js-timer-control').classList.add('hide');
		document.querySelector('.js-timer-control-pause').classList.remove('hide');

		let informationDisplays = document.querySelector('.js-tv-input').dataset.displays;
		//Push this to the website reciever.
		jQuery.ajax({
			type: "post",
			url: `${window.location.origin}/wp-admin/admin-ajax.php`,
			data: {
				action: "update_tv_display",
				tab: 'timer',
				displays: informationDisplays,
				hours: hours,
				minutes: minutes,
				seconds: seconds,
				status: 'play',
				bg: eventBG,
				direction: countDirectionDown

			},
			complete: function( response ) {
				
			}
		});

	});

	document.querySelector('.js-timer-control-pause').addEventListener('click', () => {
		let hours = Number(hoursContainer.innerHTML);
		let minutes = Number(minutesContainer.innerHTML);
		let seconds = Number(secondsContainer.innerHTML);

		document.querySelector('.js-timer-control-pause').classList.add('hide');
		document.querySelector('.js-timer-control').classList.remove('hide');

		pauseCountdown();

		//Push this to the website reciever.
		let informationDisplays = document.querySelector('.js-tv-input').dataset.displays;
		//Push this to the website reciever.
		jQuery.ajax({
			type: "post",
			url: `${window.location.origin}/wp-admin/admin-ajax.php`,
			data: {
				action: "update_tv_display",
				tab: 'timer',
				displays: informationDisplays,
				hours: hours,
				minutes: minutes,
				seconds: seconds,
				status: 'pause',
				bg: eventBG,
				direction: countDirectionDown
			},
			complete: function( response ) {
				
			}
		});
	});



	document.querySelector('.js-set-timer').addEventListener('click', () => {
		countDirectionDown = true;
		countDownPrefix = '';
		let timerContainer = document.querySelector('.js-timer-container').classList.remove('timer-red');
		pauseCountdown();

		document.querySelector('.js-update-button').innerHTML = 'Displays up to date';
		document.querySelector('.js-update-button').classList.remove('tv__button--attention');

		hoursContainer.innerHTML = document.querySelector('.js-hours-input').value.padStart(2, '0');
		minutesContainer.innerHTML = document.querySelector('.js-minutes-input').value.padStart(2, '0');
		secondsContainer.innerHTML = document.querySelector('.js-seconds-input').value.padStart(2, '0');

		document.querySelector('.js-timer-control-pause').classList.add('hide');
		document.querySelector('.js-timer-control').classList.remove('hide');

		let hours = Number(hoursContainer.innerHTML);
		let minutes = Number(minutesContainer.innerHTML);
		let seconds = Number(secondsContainer.innerHTML);

		//push this to the thing so its ready.
		let informationDisplays = document.querySelector('.js-tv-input').dataset.displays;
		//Push this to the website reciever.
		jQuery.ajax({
			type: "post",
			url: `${window.location.origin}/wp-admin/admin-ajax.php`,
			data: {
				action: "update_tv_display",
				tab: 'timer',
				displays: informationDisplays,
				hours: hours,
				minutes: minutes,
				seconds: seconds,
				status: 'set',
				bg: eventBG,
				direction: countDirectionDown
			},
			complete: function( response ) {
				
			}
		});

	});

}

let timerObject;

const countdown = (hours = 1, minutes = 30, seconds = 0) => {
	let totalSeconds = hours * 3600 + minutes * 60 + seconds;
	let timer;
	let isPaused = false;
	let hourDots = false;
	let hoursSpan = document.querySelector('.js-hours');
	let minutesSpan = document.querySelector('.js-minutes');
	let secondsSpan = document.querySelector('.js-seconds');

	if( document.querySelector('.js-hours-dots') ) {
		hourDots = document.querySelector('.js-hours-dots');
	}

	console.log(hourDots);

	const updateDisplay = () => {
		const hoursRemaining = Math.floor(totalSeconds / 3600);
		const minutesRemaining = Math.floor((totalSeconds % 3600) / 60);
		const secondsRemaining = totalSeconds % 60;


		hoursSpan.innerHTML = String(hoursRemaining).padStart(2, '0');
		minutesSpan.innerHTML = String(minutesRemaining).padStart(2, '0');
		secondsSpan.innerHTML = String(secondsRemaining).padStart(2, '0');

		document.title = countDownPrefix+String(hoursRemaining).padStart(2, '0')+':'+String(minutesRemaining).padStart(2, '0')+':'+String(secondsRemaining).padStart(2, '0');

		if( hourDots && hoursRemaining == 0 ) {
			hoursSpan.classList.add('hide');
			hourDots.classList.add('hide');
		} else if ( hourDots ) {
			hoursSpan.classList.remove('hide');
			hourDots.classList.remove('hide');
		}
	};

	const tick = () => {
		if (totalSeconds === 0 && countDirectionDown === true) {
			countDirectionDown = false;
			countDownPrefix = '-';
			let timerContainer = document.querySelector('.js-timer-container').classList.add('timer-red');
			totalSeconds++;
			updateDisplay();
		} else if(countDirectionDown === false) {
			totalSeconds++;
			updateDisplay();
		} else if (!isPaused) {
			let timerContainer = document.querySelector('.js-timer-container').classList.remove('timer-red');
			totalSeconds--;
			updateDisplay();
		}

		console.log(totalSeconds);
	};

	updateDisplay();

	timerObject = setInterval(tick, 1000);

	return {
		pause: () => {
			isPaused = true;
		},
		resume: () => {
			isPaused = false;
		},
	};
};

function pauseCountdown() {
  if (timerObject) {
    clearInterval(timerObject);
  }
}

function isOdd(num) { return num % 2;}

//refresh the page
if( document.querySelector('.js-refresh-page') ) {
	document.querySelector('.js-refresh-page').addEventListener('click', () => {

		let informationDisplays = document.querySelector('.js-tv-input').dataset.displays;
		
		jQuery.ajax({
			type: "post",
			url: `${window.location.origin}/wp-admin/admin-ajax.php`,
			data: {
				action: "update_tv_display",
				status: 'refresh',
				displays: informationDisplays,
			},
			complete: function( response ) {
				
			}
		});
	});
}

//Lets do the logic for the file uploading
if( document.querySelector('.js-holding-image-upload') ) {
	let uploadButton = document.querySelector('.js-holding-image-upload');
	let uploadFile = document.querySelector('.js-holding-image');

	uploadButton.addEventListener('click', function() {
		//process the file and shit here.
		var form_data = new FormData();
		var file_data = uploadFile.files[0];
		
		document.querySelector('.js-update-button').innerHTML = 'Update Displays <i class="fa-solid fa-spinner"></i>';
		document.querySelector('.js-update-button').classList.add('tv__button--attention');

		form_data.append('file', file_data);
		form_data.append('action', 'upload_holding_image')

		jQuery.ajax({
			type: "post",
			url: `${window.location.origin}/wp-admin/admin-ajax.php`,
			data: form_data,
			contentType: false,
			processData: false,
			success: function( res ) {
				//update bits here!
				document.querySelector('.js-image-preview').setAttribute('src', res);
			}
		});
	});
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//OVERLAY FOR POKEMON
if( document.querySelector('.js-pokemon-overlay') ) {

	//write the jquery here in a function to reuse
	function updateOverlay(player, field, dataValue) {
		jQuery.ajax({
			type: "post",
			url: `${window.location.origin}/wp-admin/admin-ajax.php`,
			data: {
				action: "update_pokemon_overlay",
				player: player,
				field: field,
				value: dataValue
			},
			complete: function( response ) {
				
			}
		});
	}

	//GENERIC DATA
	const data = document.querySelector( '.js-pokemon-overlay' );
	const player = data.dataset.player;

	////////////////////////////////////////
	//CODE FOR THE PRIZE CARDS HERE
	let prizes = document.querySelectorAll('.js-prize');
	let prizeCount = 0;
	prizes.forEach(function(prize) {
		prize.addEventListener('click', function() {
			this.classList.toggle('player-input__prize--claimed');

			if( this.classList.contains('player-input__prize--claimed') ) {
				//increment
				prizeCount = data.dataset.prizes;
				prizeCount++;
				data.dataset.prizes = prizeCount;

			} else {

				prizeCount = data.dataset.prizes;
				prizeCount--;
				data.dataset.prizes = prizeCount;
			}

			console.log(prizeCount);

			updateOverlay(player, 'prizes', prizeCount);

		});
	});

	////////////////////////////////////////
	//CODE FOR THE VSTAR COUNTER TO BE UPDATED
	const vstar = document.querySelector('.js-vstar');
	let vstarData = 0;
	vstar.addEventListener('click', function() {
		this.classList.toggle('player-input__button--used');

		if( this.classList.contains('player-input__button--used') ) {
			//increment
			vstarData = data.dataset.vstar;
			vstarData++;
			data.dataset.vstar = vstarData;

			this.innerHTML = 'V Star power used';

		} else {

			vstarData = data.dataset.vstar;
			vstarData--;
			data.dataset.vstar = vstarData;

			this.innerHTML = 'V Star power NOT used';
		}

		updateOverlay(player, 'vstar', vstarData);
	});

	////////////////////////////////////////
	//CODE FOR THE PLAYER NAME HERE
	const playerName = document.querySelector('.js-player-name');

	playerName.addEventListener('input', function() {
		let playerNameData = this.value;

		if( playerNameData.length >= 3 ) {
			updateOverlay(player, 'name', playerNameData);
		}
	});


	////////////////////////////////////////
	/// //CODE FOR THE RESET BUTTON
	const reset = document.querySelector('.js-reset-game');

	reset.addEventListener('click', function() {
		//remove prizes classes
		prizes.forEach(function(prize) {
			prize.classList.remove('player-input__prize--claimed');
		});

		//remove vstar
		vstar.classList.remove('player-input__button--used');

		data.dataset.vstar = 0;
		data.dataset.prizes = 0;

		updateOverlay(player, 'reset', 1);
	});

	////////////////////////////////////////
	/// //CODE FOR THE GAME WINS
	let gameWins = document.querySelectorAll('.js-game-win');
	gameWins.forEach(function(e) {
		e.addEventListener('change', function(j) {
			if(e.checked) {
				//incrament up
				data.dataset.gamewins++;

				updateOverlay(player, 'wins', data.dataset.gamewins);
			} else {
				//incrament down
				data.dataset.gamewins--;

				updateOverlay(player, 'wins', data.dataset.gamewins);
			}
		});
	});
}



///////////////// CAFE INPUT //////////////////////
if( document.querySelector('.js-menu-input-cafe') ) {

	//THIS DOES THE MENU TOGGLING
	let menuItems = document.querySelectorAll('.js-cafe-menu-item');
	let menuTabs = document.querySelectorAll('.js-cafe-menu-tab');
	let menuProduct = document.querySelectorAll('.js-cafe-menu-item-product');
	let menuPopupus = document.querySelectorAll('.js-cafe-menu-item-popup');
	let menuPopupsClose = document.querySelectorAll('.js-options-close');

	menuItems.forEach( function(e) {
		e.addEventListener('click', function(j) {
			menuItems.forEach( function(e) {
				e.classList.remove('resturant__input__submenu__item--active');
			});

			menuTabs.forEach( function(e) {
				e.classList.add('hide');
			});

			this.classList.add('resturant__input__submenu__item--active');

			let dataIdentifier = this.dataset.tab;

			document.querySelector('[data-target="'+dataIdentifier+'"]').classList.remove('hide');

		});
	});

	menuProduct.forEach( function(e) {
		e.addEventListener('click', function(j) {
			let popupTarget = this.dataset.popupoptions;

			document.querySelector('[data-popuptarget="'+popupTarget+'"]').classList.remove('hide');
		});
	});

	menuPopupsClose.forEach( function(e) {
		e.addEventListener('click', function(j) {
			this.parentElement.parentElement.classList.add('hide');
		})
	});

	menuPopupus.forEach( function(e) {
		e.addEventListener('click', function(j) {

			if (this.querySelector('.js-cafe-menu-item-popup-body').contains(j.target)) {
			} else{
				this.classList.toggle('hide');
			}

		});
	});

	$(document).on( 'click', 'button.plus, button.minus', function() {
      
     var qty = $( this ).parent( '.quantity' ).find( '.qty' );
     var val = parseFloat(qty.val());
     var max = parseFloat(qty.attr( 'max' ));
     var min = parseFloat(qty.attr( 'min' ));
     var step = parseFloat(qty.attr( 'step' ));

     if ( $( this ).is( '.plus' ) ) {
        if ( max && ( max <= val ) ) {
           qty.val( max ).change();
        } else {
           qty.val( val + step ).change();
        }
     } else {
        if ( min && ( min >= val ) ) {
           qty.val( min ).change();
        } else if ( val > 1 ) {
           qty.val( val - step ).change();
        }
     }

  });

}
